import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaiairporttonashikcab() {



const cardData = {
  keyword: " Navi Mumbai Airport to Nashik Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Navi Mumbai Airport to Nashik cab services for travelers looking for a smooth and convenient journey between Navi Mumbai International Airport and the holy city of Nashik. Whether you are traveling for pilgrimage, business trips, family visits, or tourism, our cab service ensures a safe and hassle-free ride with experienced drivers and well-maintained vehicles. The distance between Navi Mumbai Airport and Nashik is approximately 165–180 km depending on the route and usually takes around 3.5 to 4.5 hours by road. We offer flexible booking options including one-way transfers, round-trip packages, and multi-day travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual airport pickups, professional chauffeurs familiar with highway routes, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai Airport to Nashik cab booking.",

topPlaces: [
  {
    title: "Trimbakeshwar Temple",
    description:
      "Trimbakeshwar Temple is one of the twelve sacred Jyotirlinga temples dedicated to Lord Shiva and is located about 30 km from Nashik. The temple is known for its ancient architecture, black stone structure, and spiritual significance among Hindu pilgrims. Devotees visit to perform religious rituals, offer prayers, and seek blessings. The temple town is surrounded by hills and scenic landscapes which add to the peaceful atmosphere. Travelers arriving from Navi Mumbai Airport can conveniently reach Trimbakeshwar Temple by cab and enjoy a comfortable pilgrimage journey."
  },
  {
    title: "Sula Vineyards",
    description:
      "Sula Vineyards is one of the most famous wine destinations in India and a major attraction in Nashik. Visitors can enjoy guided vineyard tours, wine tasting sessions, and scenic views of the surrounding grape farms and hills. The winery also features restaurants, tasting rooms, and relaxing outdoor spaces where tourists can spend a pleasant day. A cab ride from Navi Mumbai Airport to Nashik makes it convenient for travelers to visit Sula Vineyards and explore the region’s wine culture."
  },
  {
    title: "Ram Kund",
    description:
      "Ram Kund is a sacred bathing ghat located on the banks of the Godavari River in Nashik. According to Hindu belief, Lord Rama is said to have taken a bath at this holy site during his exile. Pilgrims visit the ghat to perform rituals, take holy dips, and offer prayers for their ancestors. The surrounding area has many temples and religious structures, creating a deeply spiritual atmosphere. A cab service from Navi Mumbai Airport ensures comfortable travel for pilgrims visiting this holy place."
  },
  {
    title: "Pandavleni Caves",
    description:
      "Pandavleni Caves, also known as Nashik Caves, are ancient rock-cut caves dating back more than 2,000 years. Located on a hilltop, the caves feature inscriptions, sculptures, and Buddhist prayer halls carved into the rock. Visitors can climb the steps leading to the caves and enjoy panoramic views of Nashik city from the top. History enthusiasts and photographers often visit this site to admire its architecture and heritage. Traveling by cab from Navi Mumbai Airport makes it easy to reach this historic attraction."
  },
  {
    title: "Anjneri Hills",
    description:
      "Anjneri Hills are believed to be the birthplace of Lord Hanuman and are a popular trekking and pilgrimage destination near Nashik. The area is surrounded by beautiful green landscapes and peaceful natural scenery. Visitors often trek to the hilltop temple and enjoy scenic views of the surrounding mountains and valleys. A comfortable cab journey from Navi Mumbai Airport allows travelers to reach the base of Anjneri Hills and explore this spiritual and natural attraction."
  },
  {
    title: "Kalaram Temple",
    description:
      "Kalaram Temple is one of the most famous temples in Nashik dedicated to Lord Rama. The temple is known for its black stone idol of Lord Rama and its historic architecture built in the 18th century. Devotees and tourists visit the temple to seek blessings and admire its beautiful design and spiritual environment. Booking a cab from Navi Mumbai Airport provides a convenient way to reach this important religious site."
  },
  {
    title: "Godavari River Ghats",
    description:
      "The ghats along the Godavari River in Nashik are important religious and cultural landmarks where pilgrims gather for rituals, prayers, and spiritual ceremonies. The ghats become especially vibrant during festivals and during the Kumbh Mela held in Nashik. Visitors can walk along the riverbanks, watch traditional rituals, and experience the spiritual atmosphere of the city. A cab ride from Navi Mumbai Airport allows travelers to comfortably visit these sacred riverfront locations."
  },
  {
    title: "Someshwar Waterfall",
    description:
      "Someshwar Waterfall is a beautiful natural attraction located near Nashik, especially popular during the monsoon season when water flows strongly over the rocky terrain. Visitors enjoy the scenic views, cool breeze, and peaceful surroundings near the waterfall. It is also a great location for photography and short nature outings. A cab trip from Navi Mumbai Airport to Nashik allows travelers to comfortably include this refreshing destination in their travel plan."
  },
  {
    title: "Muktidham Temple",
    description:
      "Muktidham Temple is a unique marble temple complex in Nashik known for its replicas of all twelve Jyotirlingas of Lord Shiva. The temple also features carvings of scenes from the Mahabharata and other Hindu scriptures. Visitors can explore the temple complex and learn about Hindu mythology and traditions. Traveling by cab from Navi Mumbai Airport ensures convenient access to this spiritual and cultural attraction."
  },
  {
    title: "Coin Museum",
    description:
      "The Coin Museum in Nashik is an interesting attraction for history enthusiasts and collectors. The museum displays a large collection of coins from different periods of Indian history, including ancient, medieval, and modern eras. Visitors can learn about the evolution of currency and trade through informative exhibits. A cab service from Navi Mumbai Airport to Nashik allows travelers to comfortably include this educational attraction in their sightseeing itinerary."
  }
],



services: [
{
name: "Navi Mumbai Airport to Nashik Cab",
description: "Navi Mumbai Airport to Nashik cab service provides reliable and comfortable transportation for travelers arriving at Navi Mumbai International Airport and heading to Nashik city. This route is commonly used by pilgrims visiting Trimbakeshwar Jyotirlinga, tourists exploring Nashik vineyards, and business travelers. Our fleet includes AC sedans, SUVs, and premium MPV vehicles designed for smooth highway journeys. Professional drivers ensure safe driving and punctual pickup directly from airport terminals. Spacious seating and luggage capacity make travel comfortable for families and groups. Ideal for temple visits, tourism trips, and corporate travel."
},
{
name: "Navi Mumbai Airport to Nashik Taxi",
description: "Navi Mumbai Airport to Nashik taxi service offers dependable intercity transportation between Navi Mumbai airport and Nashik. Vehicles provide comfortable seating and smooth ride quality suitable for long-distance highway travel. Professional drivers ensure punctual pickup from airport terminals and safe driving throughout the journey. Air-conditioned vehicles ensure relaxed travel during the trip. Ideal for pilgrims visiting Trimbakeshwar temple, tourists visiting vineyards, and corporate travelers."
},
{
name: "Cab from Navi Mumbai Airport to Nashik",
description: "Cab from Navi Mumbai Airport to Nashik provides convenient airport pickup and direct transfer to Nashik city. Vehicles provide comfortable seating and smooth ride performance suitable for long-distance travel. Professional drivers ensure punctual pickup services from the airport terminal and safe driving along the highway route. Spacious luggage capacity makes it convenient for travelers arriving with baggage."
},
{
name: "Taxi from Navi Mumbai Airport to Nashik",
description: "Taxi from Navi Mumbai Airport to Nashik offers reliable airport transportation for passengers traveling directly from the airport to Nashik. Vehicles provide comfortable seating, air-conditioned interiors, and smooth ride quality suitable for highway journeys. Professional drivers ensure punctual airport pickups and safe driving throughout the route."
},
{
name: "Navi Mumbai Airport Nashik Cab Service",
description: "Navi Mumbai Airport Nashik cab service provides comfortable transportation for travelers visiting Nashik city and nearby religious destinations. Vehicles are well maintained and suitable for highway travel. Professional drivers ensure safe driving and timely pickup from airport terminals. Ideal for pilgrims visiting Trimbakeshwar Jyotirlinga, tourists exploring Nashik vineyards, and family travel."
},
{
name: "Navi Mumbai Airport Nashik Taxi Service",
description: "Navi Mumbai Airport Nashik taxi service provides dependable intercity travel for passengers traveling between Navi Mumbai airport and Nashik. Vehicles provide comfortable seating and reliable highway performance suitable for long journeys. Professional drivers ensure punctual pickup services and safe travel throughout the route."
},
{
name: "Navi Mumbai Airport to Nashik Cab Booking",
description: "Navi Mumbai Airport to Nashik cab booking allows passengers to easily reserve vehicles for airport transfers with instant confirmation. Online and phone booking options provide convenient travel scheduling. Vehicles provide comfortable seating and reliable highway performance suitable for the journey."
},
{
name: "Navi Mumbai Airport to Nashik Taxi Booking Online",
description: "Navi Mumbai Airport to Nashik taxi booking online provides fast and convenient reservations for passengers planning airport transfers. Travelers can schedule rides online and receive quick booking confirmation. Vehicles provide comfortable seating and smooth ride quality suitable for long-distance travel."
},
{
name: "Navi Mumbai Airport to Nashik Cab Price",
description: "Navi Mumbai Airport to Nashik cab price options provide transparent fare estimates depending on vehicle category and travel distance. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size. Clear pricing helps passengers plan their travel budget easily."
},
{
name: "Navi Mumbai Airport to Nashik Taxi Fare",
description: "Navi Mumbai Airport to Nashik taxi fare services offer flexible pricing depending on vehicle type and trip duration. Passengers can select economical sedans or spacious SUVs depending on their travel preferences."
},
{
name: "Navi Mumbai Airport to Nashik One Way Cab",
description: "Navi Mumbai Airport to Nashik one way cab service provides economical travel without return charges. This option helps reduce travel cost while ensuring comfortable airport transfers. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys."
},
{
name: "Navi Mumbai Airport to Nashik Round Trip Taxi",
description: "Navi Mumbai Airport to Nashik round trip taxi service provides convenient transportation for passengers planning return journeys. Vehicles remain available as per travel schedule ensuring comfortable travel in both directions."
},
{
name: "Navi Mumbai Airport to Nashik Innova Cab",
description: "Navi Mumbai Airport to Nashik Innova cab service provides spacious MPV transportation ideal for families and small groups traveling with luggage. Toyota Innova vehicles offer comfortable seating and smooth highway performance suitable for airport transfers."
},
{
name: "Navi Mumbai Airport to Nashik Ertiga Cab",
description: "Navi Mumbai Airport to Nashik Ertiga cab service provides comfortable MPV transportation suitable for families and group travelers. The Maruti Ertiga offers spacious seating and smooth ride quality ideal for expressway journeys."
},
{
name: "Trimbakeshwar Cab from Navi Mumbai Airport",
description: "Trimbakeshwar cab from Navi Mumbai Airport provides direct transportation for devotees visiting the sacred Trimbakeshwar Jyotirlinga temple near Nashik. Vehicles provide comfortable seating and reliable highway performance suitable for pilgrimage travel. Professional drivers ensure safe driving and timely pickup services from the airport."
}
],

tableData: [
["Navi Mumbai Airport to Nashik Cab","Navi Mumbai Airport to Nashik Taxi"],
["Cab from Navi Mumbai Airport to Nashik","Taxi from Navi Mumbai Airport to Nashik"],
["Navi Mumbai Airport Nashik Cab Service","Navi Mumbai Airport Nashik Taxi Service"],
["Navi Mumbai Airport to Nashik Cab Booking","Navi Mumbai Airport to Nashik Taxi Booking Online"],
["Navi Mumbai Airport to Nashik Cab Price","Navi Mumbai Airport to Nashik Taxi Fare"],
["Navi Mumbai Airport to Nashik One Way Cab","Navi Mumbai Airport to Nashik Round Trip Taxi"],
["Navi Mumbai Airport to Nashik Innova Cab","Navi Mumbai Airport to Nashik Ertiga Cab"],
["Trimbakeshwar Cab from Navi Mumbai Airport","Nashik Airport Transfer Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance travel from Navi Mumbai Airport to Nashik. They are familiar with major highway routes including NH160 and the Mumbai–Nashik corridor, ensuring a smooth and safe journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Navi Mumbai Airport to Nashik cab bookings. Customers receive clear details about per-kilometer fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport to Nashik cab service operates 24 hours a day. Whether your flight arrives early morning or late at night, we provide reliable airport pickup services anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to ensure passengers enjoy a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way airport pickup, round-trip travel, and same-day return packages between Navi Mumbai Airport and Nashik."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Direct Airport Pickup Service",
    WhyChoosedescription: "Our drivers provide convenient pickup directly from Navi Mumbai Airport terminals and assist passengers with luggage for a comfortable start to the journey."
  },
  {
    WhyChooseheading: "Reliable Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai Airport to Nashik trips thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Navi Mumbai Airport to Nashik?", answer: "Yes, Omshree Cabs provides reliable cab services from Navi Mumbai Airport to Nashik for both one-way and round-trip travel." },
  { question: "What is the distance from Navi Mumbai Airport to Nashik?", answer: "The distance from Navi Mumbai Airport to Nashik is approximately 170 km and the journey usually takes around 3.5 to 4 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Navi Mumbai Airport to Nashik?", answer: "Yes, we offer both one-way and round-trip cab services between Navi Mumbai Airport and Nashik." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight arrival schedules." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours and weekends." },
  { question: "Do drivers track flight arrival times?", answer: "Yes, our drivers monitor flight schedules to ensure timely pickup even if flights are delayed." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "We booked Omshree Cabs from Navi Mumbai Airport to Nashik. The driver arrived on time and the journey was very smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shah",
    feedback:
      "Excellent airport transfer service. Clean car, professional driver, and comfortable travel to Nashik.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Navi Mumbai Airport to Nashik Cab Service",
  "description": "Omshree Cab provides reliable cab service from Navi Mumbai Airport to Nashik. Book one-way or round-trip cabs in Innova, Ertiga, or sedan for safe and comfortable travel.",
  "provider": {
    "@type": "Organization",
    "name": "Omshree Cab",
    "telephone": "+91 9892544084",
    "url": "https://www.omshreecab.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": "Outstation Cab Service"
};








  return (
    <div>
      

<Helmet>
  <title>Navi Mumbai Airport to Nashik Cab | Omshree Cab | One-way & Round Trip</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai Airport to Nashik cab service with Omshree Cab. Get one-way or round-trip pickups in Innova, Ertiga, or sedan cabs. Safe, reliable, and available 24/7." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairporttonashikcab;